<!-- eslint-disable vue/max-len -->
<template>
  <svg
    :class="`color-stroke-${color}`"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="3"
      y="5"
      width="18"
      height="14"
      rx="1"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <mask id="path-2-inside-1_4324_25206" fill="white">
      <path
        stroke="initial"
        d="M5 15.5C5 13.9523 5.55223 12.4554 6.55736 11.2786C7.56249 10.1017 8.95456 9.32213 10.4832 9.08003C12.0118 8.83792 13.5766 9.14918 14.8962 9.95784C16.2158 10.7665 17.2036 12.0195 17.6819 13.4914L15.8273 14.094C15.4925 13.0636 14.8011 12.1865 13.8774 11.6205C12.9536 11.0544 11.8583 10.8365 10.7882 11.006C9.71819 11.1755 8.74374 11.7212 8.04015 12.545C7.33656 13.3688 6.95 14.4166 6.95 15.5H5Z"
      />
    </mask>
    <path
      d="M5 15.5C5 13.9523 5.55223 12.4554 6.55736 11.2786C7.56249 10.1017 8.95456 9.32213 10.4832 9.08003C12.0118 8.83792 13.5766 9.14918 14.8962 9.95784C16.2158 10.7665 17.2036 12.0195 17.6819 13.4914L15.8273 14.094C15.4925 13.0636 14.8011 12.1865 13.8774 11.6205C12.9536 11.0544 11.8583 10.8365 10.7882 11.006C9.71819 11.1755 8.74374 11.7212 8.04015 12.545C7.33656 13.3688 6.95 14.4166 6.95 15.5H5Z"
      stroke-width="4"
      stroke-miterlimit="10"
      stroke-linecap="round"
      mask="url(#path-2-inside-1_4324_25206)"
    />
    <path d="M18 10V14H14" stroke-width="2" stroke-miterlimit="10" stroke-linecap="square" />
  </svg>
</template>

<script setup lang="ts">
interface icon {
  color?: string;
}

withDefaults(defineProps<icon>(), {
  color: 'black',
});
</script>
